import React from "react";
import {
  Button,
  Paper,
  InputBase,
  IconButton,
  List,
  ListItem,
  Divider,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { Add, Search } from "@material-ui/icons";

import Logo from "../../../../getKampus.png";

const useStyles = makeStyles((theme) => ({
  main: {
    // borderRight: "1px solid darkblue",
    height: "85vh",
    display: "flex",
    flexDirection: "column",
  },
  addButton: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  search: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2px 4px",
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  title: {
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(2),
    fontWeight: 700,
  },
  inputSearch: {
    flex: 1,
    paddingLeft: theme.spacing(1),
  },
  list: {
    width: "100%",
    // maxWidth: "40ch",
    backgroundColor: theme.palette.background.paper,
    // height: "70%",
    overflowY: "scroll",
    marginBottom: theme.spacing(1),
  },
  inline: {
    display: "inline",
  },
}));

export default function ChatList() {
  const classes = useStyles();

  const handleSearch = (event) => {
    event.preventDefault();
  };

  return (
    <div className={classes.main}>
      <div className={classes.addButton}>
        <Avatar src={Logo} style={{marginRight: 10}} />
        <Button startIcon={<Add />} variant="contained" color="primary">
          New Conversation
        </Button>
      </div>
      <Typography variant="h5" gutterBottom className={classes.title}>
        Chats
      </Typography>
      <Paper
        component="form"
        className={classes.search}
        onSubmit={handleSearch}
      >
        <InputBase className={classes.inputSearch} placeholder="Search Chat" />
        <IconButton
          type="submit"
          className={classes.iconButton}
          aria-label="search"
        >
          <Search />
        </IconButton>
      </Paper>
      <List className={classes.list}>
        <ListItem alignItems="flex-start" button>
          <ListItemAvatar>
            <Avatar alt="Remy Sharp" src={Logo} />
          </ListItemAvatar>
          <ListItemText
            primary="National University of Singapore"
            secondary={
              <React.Fragment>
                <Typography
                  component="span"
                  variant="body2"
                  className={classes.inline}
                  color="textPrimary"
                >
                  Ali Connors
                </Typography>
                {" — I'll be in your neighborhood doing errands this…"}
              </React.Fragment>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" />
        <ListItem alignItems="flex-start" button>
          <ListItemAvatar>
            <Avatar alt="Travis Howard" src={Logo} />
          </ListItemAvatar>
          <ListItemText
            primary="Nanyang Technological University"
            secondary={
              <React.Fragment>
                <Typography
                  component="span"
                  variant="body2"
                  className={classes.inline}
                  color="textPrimary"
                >
                  to Scott, Alex, Jennifer
                </Typography>
                {" — Wish I could come, but I'm out of town this…"}
              </React.Fragment>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" />
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar alt="Cindy Baker" src={Logo} />
          </ListItemAvatar>
          <ListItemText
            primary="Singapore Management University"
            secondary={
              <React.Fragment>
                <Typography
                  component="span"
                  variant="body2"
                  className={classes.inline}
                  color="textPrimary"
                >
                  Sandra Adams
                </Typography>
                {" — Do you have Paris recommendations? Have you ever…"}
              </React.Fragment>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" />
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar alt="Cindy Baker" src={Logo} />
          </ListItemAvatar>
          <ListItemText
            primary="Singapore Management University"
            secondary={
              <React.Fragment>
                <Typography
                  component="span"
                  variant="body2"
                  className={classes.inline}
                  color="textPrimary"
                >
                  Sandra Adams
                </Typography>
                {" — Do you have Paris recommendations? Have you ever…"}
              </React.Fragment>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" />
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar alt="Cindy Baker" src={Logo} />
          </ListItemAvatar>
          <ListItemText
            primary="Singapore Management University"
            secondary={
              <React.Fragment>
                <Typography
                  component="span"
                  variant="body2"
                  className={classes.inline}
                  color="textPrimary"
                >
                  Sandra Adams
                </Typography>
                {" — Do you have Paris recommendations? Have you ever…"}
              </React.Fragment>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" />
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar alt="Cindy Baker" src={Logo} />
          </ListItemAvatar>
          <ListItemText
            primary="Singapore Management University"
            secondary={
              <React.Fragment>
                <Typography
                  component="span"
                  variant="body2"
                  className={classes.inline}
                  color="textPrimary"
                >
                  Sandra Adams
                </Typography>
                {" — Do you have Paris recommendations? Have you ever…"}
              </React.Fragment>
            }
          />
        </ListItem>
      </List>
    </div>
  );
}
